"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const constants = require("@/common/constants");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
const vueRoot_1 = require("@/client/components/vueRoot");
const paths_1 = require("@/common/app/paths");
exports.default = vue_1.default.extend({
    name: 'LoadGameForm',
    components: {
        AppButton: AppButton_vue_1.default,
    },
    data() {
        return {
            gameId: undefined,
            rollbackCount: 0,
        };
    },
    methods: {
        loadGame() {
            const gameId = this.gameId;
            const rollbackCount = this.rollbackCount;
            if (gameId === undefined) {
                alert('Specify a game id');
                return;
            }
            const loadGameForm = {
                gameId,
                rollbackCount,
            };
            fetch(paths_1.paths.LOAD_GAME, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(loadGameForm),
            })
                .then((resp) => {
                if (!resp.ok) {
                    throw new Error(`Error getting game data: ${resp.statusText}`);
                }
                return resp.json();
            })
                .then((response) => {
                if (response.players.length === 1) {
                    window.location.href = 'player?id=' + response.players[0].id;
                    return;
                }
                else {
                    window.history.replaceState(response, `${constants.APP_NAME} - Game`, 'game?id=' + response.id);
                    (0, vueRoot_1.vueRoot)(this).game = response;
                    (0, vueRoot_1.vueRoot)(this).screen = 'game-home';
                }
            })
                .catch((err) => {
                alert('Error loading game');
                console.error(err);
            });
        },
    },
    computed: {
        APP_NAME() {
            return constants.APP_NAME;
        },
    },
});
